export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const hasBluetooth =
  "bluetooth" in window.navigator &&
  typeof window.navigator.bluetooth.getAvailability === "function";
const hasUSB =
  "usb" in window.navigator &&
  typeof window.navigator.usb.getDevices === "function";
const hasConnection = "connection" in window.navigator;
const hasVibrate =
  "vibrate" in window.navigator &&
  typeof window.navigator.vibrate === "function";
const hasVirtualKeyboard = "virtualKeyboard" in window.navigator;
const hasHoverCapability =
  window.matchMedia &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(hover: hover)").matches;

export const getBluetooth = async (meta) => {
  if (hasBluetooth) {
    meta.bluetooth = {};
    meta.bluetooth.isAvailable =
      await window.navigator.bluetooth.getAvailability();
  }
};

export const getUSB = async (meta) => {
  if (hasUSB) {
    meta.usb = {};
    meta.usb.devices = await window.navigator.usb.getDevices();
  }
};

export const getMimeTypes = (meta) => {
  meta.mimeTypes = {};
  for (const mimeType of window.navigator.mimeTypes) {
    const typeName = mimeType.type;
    meta.mimeTypes[typeName] = {};
    meta.mimeTypes[typeName].description =
      window.navigator.mimeTypes[typeName].description;
    meta.mimeTypes[typeName].suffixes =
      window.navigator.mimeTypes[typeName].suffixes;
    meta.mimeTypes[typeName].type = window.navigator.mimeTypes[typeName].type;
  }
};

export const getConnection = (meta) => {
  if (hasConnection) {
    meta.connection = {};
    meta.connection.downlink = window.navigator.connection.downlink;
    meta.connection.effectiveType = window.navigator.connection.effectiveType;
    meta.connection.rtt = window.navigator.connection.rtt;
    meta.connection.saveData = window.navigator.connection.saveData;
  }
};

export const getPlugins = (meta) => {
  meta.plugins = {};
  for (const plugin of window.navigator.plugins) {
    meta.plugins[plugin.name] = {};
    meta.plugins[plugin.name].description =
      window.navigator.plugins[plugin.name].description;
    meta.plugins[plugin.name].filename =
      window.navigator.plugins[plugin.name].filename;
    meta.plugins[plugin.name].length =
      window.navigator.plugins[plugin.name].length;
    meta.plugins[plugin.name].name = window.navigator.plugins[plugin.name].name;
  }
};

export const getVibrate = (meta) => {
  if (hasVibrate) {
    meta.vibrate = true;
  }
};

export const getVirtualKeyboard = (meta) => {
  if (hasVirtualKeyboard) {
    meta.virtualKeyboard = true;
  }
};

export const getMatchMediaHover = (meta) => {
  if (hasHoverCapability) {
    meta.matchMediaHover = true;
  }
};

export const getIsAutomated = (meta) => {
  meta.isAutomated = window.navigator.webdriver;
};

// Calculate mean and standard deviation for an array of values
export const calculateStats = (values) => {
  if (values.length === 0) return { mean: undefined, std: undefined };

  const mean = values.reduce((sum, val) => sum + val, 0) / values.length;
  const variance =
    values.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) /
    values.length;
  const std = Math.sqrt(variance);

  return { mean, std };
};

// Extract values from readings array using a dot-notation path (e.g., 'acceleration.x' or 'x')
export const getValuesForPath = (readings, path) => {
  return readings
    .map((r) => path.split(".").reduce((obj, key) => obj?.[key], r))
    .filter((val) => val !== undefined && val !== null && !isNaN(val));
};
